import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: 1rem 2rem;
  text-align: center;
  background-color: #eee; /* Light gray background */
  color: #333;
`;

const Copyright = styled.a`
  margin: 0;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Copyright href="https://digitalservices.ma" target="_blank" rel="noopener noreferrer">
        &copy; {new Date().getFullYear()} Rais Digital Services
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
